import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { StructureNodeSelectionComponent } from './structure-node-selection.component';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule,
    MatSelectModule
  ],
  declarations: [
    StructureNodeSelectionComponent,
  ],
  exports: [
    StructureNodeSelectionComponent
  ]
})
export class StructureNodeSelectionModule { }
